module.exports = __webpack_public_path__ + "static/img/product_manufacture_UniCoal.3b67b43.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_manufacture_UniCoal.png
// module id = /3So
// module chunks = 0